import React, { useContext, useState, useEffect } from 'react';
import './topnav.css';
import { Link } from 'react-router-dom';
import Dropdown from '../dropdown/Dropdown';
import ThemeMenu from '../thememenu/ThemeMenu';
import user_menu from '../../assets/JsonData/user_menus.json';
import { ProductContext } from "../../ProductProvider";
import logo from '../../assets/images/logo/COLLEGELOGO.jpeg';

const renderUserToggle = (user) => (
    <div className="topnav__right-user">
        <div className="topnav__right-user__image">
            <img 
              src={user.image} 
              alt={user.display_name} 
              onError={(e) => {
                e.target.src = "https://s3.ap-south-1.amazonaws.com/idntica.com/avatar/profileImage/defaultAvatar.jpeg";
              }}
            />
            <span className="user-online-status"></span>
        </div>
        <div className="topnav__right-user__info d-none d-md-flex">
            <span className="topnav__right-user__name">{user.display_name || 'Student'}</span>
            <span className="topnav__right-user__role">{user.role || 'Student'}</span>
        </div>
        <i className="fa fa-angle-down ms-1 d-none d-md-inline" style={{ fontSize: '0.85rem', color: 'var(--txt-muted)' }}></i>
    </div>
);

const renderUserMenu = (item, index) => (
    <Link to={item.linkTo} key={index} className="user-menu-link">
        <div className="notification-item">
            <i className={item.icon}></i>
            <span>{item.content}</span>
        </div>
    </Link>
);

const renderUserMenuFooter = () => (
    <div className="d-flex align-items-center justify-content-between px-3 py-2 text-muted small" style={{ fontSize: '0.75rem', background: 'rgba(148, 163, 184, 0.06)' }}>
        <span className="fw-semibold">Portal Version</span>
        <span className="badge bg-primary-soft text-primary fw-bold" style={{ fontSize: '0.72rem', padding: '3px 8px', borderRadius: '6px' }}>
            v1.0.0
        </span>
    </div>
);

const Topnav = ({ toggleMobileSidebar }) => {
    const { loggedUser, myProfileImage } = useContext(ProductContext);
    const [curr_user, setCurrUser] = useState({ display_name: 'Student', image: '', role: 'Student' });

    useEffect(() => {
        setCurrUser({
            display_name: loggedUser.name || 'Student',
            image: myProfileImage,
            role: loggedUser.profile || 'Student'
        });
    }, [loggedUser, myProfileImage]);
    
    return (
        <header className='topnav'>
            <div className="topnav__left">
                {toggleMobileSidebar && (
                    <button 
                        className="mobile-menu-toggle d-inline-flex d-md-none" 
                        onClick={toggleMobileSidebar}
                        aria-label="Toggle navigation menu"
                    >
                        <i className="fa fa-bars" aria-hidden="true"></i>
                    </button>
                )}
                
                <Link to="/" className="topnav__brand">
                    <img src={logo} alt="VJ Crest" className="topnav__logo" />
                    <div className="topnav__brand-text">
                        <span className="topnav__college-title">Vidyajyoti College</span>
                        <span className="topnav__portal-badge">Student Portal</span>
                    </div>
                </Link>
            </div>

            <div className="topnav__right">
                <div className="topnav__right-item">
                    <ThemeMenu />
                </div>
                
                <div className="topnav__right-item">
                    <Dropdown
                        customToggle={() => renderUserToggle(curr_user)}
                        contentData={user_menu}
                        renderItems={(item, index) => renderUserMenu(item, index)}
                        renderFooter={() => renderUserMenuFooter()}
                    />
                </div>
            </div>
        </header>
    );
};

export default Topnav;
